import React from "react";
import styled from "styled-components";
import { PRIMARY } from "../../../../vars/vars";
import { Link } from "react-router-dom";

const InfoPart = ({ link, header, photoUrl, catalogue, children }) => (
  <Part>
    <Header to={"/details/" + link}>{header}</Header>
    <Link to={"/details/" + link}>
      <StyledImg src={photoUrl} />
    </Link>
    <div>
      <View to={"/details/" + link}>View now</View>
      <Additional to={"/parts" + catalogue}>Additional options</Additional>
      {children}
    </div>
  </Part>
);

export default InfoPart;

const StyledImg = styled.img`
  width: 100%;
`;

const View = styled(Link)`
  display: block;
  margin-bottom: 5px;
  color: white;
  background-color: #50be19;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 12px;

  &:hover {
    background-color: #48ab16;
    color: white;
  }
`;

const Additional = styled(Link)`
  display: block;
  margin-bottom: 20px;
  color: white;
  background-color: #333333;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 12px;

  &:hover {
    background-color: ${PRIMARY};
    color: white;
  }
`;

const Header = styled(Link)`
  color: #666666;
  font-weight: 600;
  line-height: 18px;

  &:hover {
    color: #666666;
  }
`;

const Part = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #dadada;
  border-radius: 2px;
  text-align: center;
  margin-bottom: 20px;

  &:hover {
    border-color: ${PRIMARY};
  }
`;
